module.exports = __webpack_public_path__ + "04f5ed4844a2d148279e17a33953a48d.jpg";